import pipe from 'lodash/fp/pipe'
import round from '../round'
import average from './average'

const averageWithRound = (array = [], iteratee = '') =>
  pipe(average, round)(array, iteratee)

export default averageWithRound
